import { Pipe, PipeTransform } from '@angular/core';
import { CustomFieldModel } from '@base/modules/rest/custom-field/model/custom-field.model';
import { capitalizePath, pathSkipFirst, pathSkipLast } from '@base/utils/common.util';
import { ObjectCompositeFilterItemModel } from '../model/object-composite-filter-item.model';

export function findFieldForFilter(fields: CustomFieldModel[], filter: ObjectCompositeFilterItemModel): CustomFieldModel {
  if (!fields) {
    return null;
  }
  const path = capitalizePath(pathSkipFirst(filter.beanName + '.' + filter.fieldName));
  const field = fields
    .find(f => path === capitalizePath(f.dbName));
  if (field) {
    return field;
  }
  return fields
    .find(f => pathSkipLast(path) === capitalizePath(f.dbName));
}

@Pipe({
  name: 'appliedFiltersChipsDisplay',
})
export class AppliedFiltersChipsDisplayPipe implements PipeTransform {

  transform(filter: ObjectCompositeFilterItemModel, fields: CustomFieldModel[]): string {
    const field = findFieldForFilter(fields, filter);
    const fieldName = this.calcFieldName(field);
    return `${fieldName}`;
  }

  private calcFieldName(field: CustomFieldModel): string {
    return field?.label;
  }
}
